import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { VehicleSourcePicker } from "@/components/VehicleSourcePicker";
import { DeliveryPlacePicker } from "@/components/DeliveryPlacePicker";

export const CopyLinkConfirm = ({ quote, onClose, onGo, t }) => (
  <Dialog open={!!quote} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent data-testid="copy-link-confirm-dialog" className="max-w-md">
      <DialogHeader>
        <DialogTitle>{t("Copier le lien vers le devis")} — {quote?.quote_number}</DialogTitle>
      </DialogHeader>
      <div className="text-sm text-muted-foreground">{t("Origine du véhicule enregistrée. Copier le lien de signature du devis ?")}</div>
      <DialogFooter>
        <Button variant="outline" onClick={onClose} data-testid="copy-link-confirm-cancel">{t("Annuler")}</Button>
        <Button onClick={() => onGo(quote)} data-testid="copy-link-confirm-go">{t("Copier le lien")}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const VehicleSourceDialog = ({ quote, onClose, onConfirm, t }) => {
  const [value, setValue] = useState("");
  const [loc, setLoc] = useState("");
  useEffect(() => { setValue(""); setLoc(""); }, [quote]);
  return (
    <Dialog open={!!quote} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="vehicle-source-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t("Origine du véhicule")} — {quote?.quote_number}</DialogTitle>
        </DialogHeader>
        <VehicleSourcePicker value={value} onChange={setValue} t={t} />
        {value === "stock" && (
          <div data-testid="dialog-stock-location-block">
            <div className="text-xs text-muted-foreground">{t("Lieu de stockage")}</div>
            <DeliveryPlacePicker value={loc} onChange={setLoc} testid="dialog-stock-location" placeholder="Choisir le lieu de stockage" autoOwn />
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="vehicle-source-cancel">{t("Annuler")}</Button>
          <Button disabled={!value} onClick={() => onConfirm(value, loc)} data-testid="vehicle-source-confirm">{t("Continuer vers la signature")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
